import qs from 'qs';
import { toUnderscoreObject } from 'helpers/toUnderscore';
import dotToPath from 'helpers/dotToPath';
import cleanDeep from 'clean-deep';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const platformsEndPoint = {
  dataURL: 'education/platforms',
  sourceName: 'platformsList',
  autoLoad: true,
  getDataUrl: (url, { page, perPage, filters: { name, ...filtersRest }, sort, search }) => {
    const urlData = {
      filters: toUnderscoreObject(dotToPath({ ...filtersRest, search: name }), false)
    };

    if (sort && typeof sort === 'object' && !Array.isArray(sort)) {
      Object.entries(sort).forEach(([key, value]) => {
        urlData[`sort.${key}`] = value;
      });
    } else if (typeof sort !== 'undefined') {
      urlData.sort = sort;
    }

    if (search) {
      urlData.search = search;
    }

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    const { meta } = payload || {};
    const { limit, count, offset } = meta || {};

    return {
      data: concat ? (state.data || []).concat(payload) : payload,
      page: Math.ceil(Number(offset) / Number(limit)) + 1,
      perPage: limit,
      count
    };
  }
};

export default platformsEndPoint;
